import { useState, useEffect } from 'react';

import { useSnackbar } from "notistack";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

import {
    StripeFormContainer,
} from '../../../Styles/Billings/checkoutStyles';

import { useLoadingScreen } from '../../../Store/LoadingManager';

import { useBillingHook } from '../../../Hooks/Billings/billingHooks';

import { StripeFormInterface } from '../../../Models/Common/CustomViewsInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { MakePaymentField, StripePaymentIntentField, BuyLicenseField, InvoiceField, CheckoutDataField, DetailsInvoiceField } from '../../../Utilities/Enums/ParametersEnum';

import { GlobalSettingsConstants } from '../../../Constants/GlobalConstants';
import { ErrorMessage } from '../../../Constants/Messages';

import CustomButton from '../../../CustomViews/Elements/CustomButton';

export default function PaymentInfo(props: StripeFormInterface) {
    const stripe: any = useStripe();
    const elements: any = useElements();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    let { loading, setLoading } = useLoadingScreen();
    
     //Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.BILLINGS, queryStr];
    const { DropdownData, dropdownFetchStatus, stripemakePayment, getBillingById } = useBillingHook(q_queryKey, queryStr, false);
    
    
    //Variables
    let prevStep: any = props?.stepperItems?.find((step: any) => step.id == (props?.selectedStep?.id - 1)) ?? null;
    let nextStep: any = props?.stepperItems?.find((step: any) => step.id == (props?.selectedStep?.id + 1)) ?? null;

    //Event Handlers
    const getInvoiceDetails = async (invoicePublicId: string | number) => {
        if(invoicePublicId) {
            let getInvoice = await getBillingById(invoicePublicId);
            
            if(props.setinvoiceId) {
                props.setinvoiceId(getInvoice?.data?.[DetailsInvoiceField.TRANS_NO] ?? "");
            }

            if(props.setlicenseKey) {
                props.setlicenseKey(getInvoice?.data?.[DetailsInvoiceField.GENERATED_LICENSE_KEY] ?? "");
            }

            if(props.setinvoicePublicId) {
                props.setinvoicePublicId(invoicePublicId);
            }

            if(props.setlicensePublicId) {
                props.setlicensePublicId(getInvoice?.data?.[DetailsInvoiceField.GENERATED_LICENSE_PUBLIC_ID] ?? "");
            }
        }

        return true;
    }

    const handlePay = async (e: any) => {
        e.preventDefault();

        try {
            const { error: submitError } = await elements.submit();

            if (submitError) {
                enqueueSnackbar(ErrorMessage.FIELD_REQUIRED, { variant: 'error'});
                return false;
            } else {
                let _success = false;
                let _formdata = (!props.isFromBilling ?
                    {
                        ...props?.formData,
                        [BuyLicenseField.INVOICE]: {
                            ...props?.formData?.[BuyLicenseField.INVOICE],
                            [InvoiceField.BILLING_DETAILS]: props.checkoutFormData?.[CheckoutDataField.BILLING_DETAILS],
                        }
                    } : { ...props?.formData }
                );

                let stripemakePaymentResponse = await stripemakePayment(JSON.stringify(_formdata));
                
                if(stripemakePaymentResponse?.isSuccess) {
                    const clientSecret = stripemakePaymentResponse?.data?.data?.[MakePaymentField.CLIENT_SECRET_KEY] ?? "";
                    const invoicePublicId =  stripemakePaymentResponse?.data?.data?.[MakePaymentField.INVOICE_PUBLIC_ID] ?? "";
                    let _msg = "";

                    const { error, paymentIntent } = await stripe.confirmPayment({
                        elements,
                        clientSecret,
                        confirmParams: {
                            return_url: GlobalSettingsConstants.STRIPE_RETURN_URL,
                        },
                        redirect: "if_required",
                    });

                    if (error) {
                        _msg = error.message;
                    } else if (paymentIntent) {
                        _success = true;
                        _msg = `Payment status: ${paymentIntent?.[StripePaymentIntentField.STATUS]}`;
                    }

                    if(_success) {
                        await GlobalFunctionHelper.timeout(3000);
                        await getInvoiceDetails(invoicePublicId);

                        if(props.setisSuccessPayment) {
                            props.setisSuccessPayment(_success);
                        }
                    }

                    if(!_success) {
                        enqueueSnackbar(_msg, { variant: _success ? 'success' : 'error'});
                    }
                }

                return _success;
            }
        } catch (err) {
            enqueueSnackbar(ErrorMessage.PROBLEM_CREATING_OR_CONFIRMING_PAYMENT, { variant: 'error'});
            return false;
        // } finally {
        //     return false;
        }
    }

    return <StripeFormContainer>
        <PaymentElement />

        <div className="nextPrevContainer">
             {(prevStep?.id && nextStep?.id) ? <CustomButton
                className="prevBtn"
                btnType={ButtonType.CANCEL}
                title={'Back to ' + prevStep?.btnName ?? ""} 
                startIcon={<IconArrowLeft />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    if(props?.setselectedStep) {
                        props.setselectedStep(prevStep);
                    }
                }} /> : <div />}
            
            {nextStep?.id && <CustomButton
                className="nextBtn"
                btnType={ButtonType.PRIMARY}
                title={nextStep?.btnName ?? ""} 
                endIcon={<IconArrowRight />}
                onClick={async (e: any) => {
                    setLoading(true);

                    let _handlePay = await handlePay(e);
                    
                    if(_handlePay && props?.setselectedStep) {
                        props.setselectedStep(nextStep);
                    }

                    setLoading(false);
                }} />}
        </div>
    </StripeFormContainer>

}
